import { supabase } from '@/lib/supabase'

export type VisionLockedPeopleMode = 'messages' | 'avatars'
export type VisionLockedPeopleConfig = {
  enabled: boolean
  mode: VisionLockedPeopleMode
}

const KEY_ENABLED = 'ui.vision.locked_card_people.enabled'
const KEY_MODE = 'ui.vision.locked_card_people.mode'

export async function getVisionLockedPeopleConfig(): Promise<VisionLockedPeopleConfig> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('key,value')
    .in('key', [KEY_ENABLED, KEY_MODE])
  if (error) throw error

  const map = new Map<string, string>((data || []).map((r: any) => [String(r.key), String(r.value || '')]))
  const enabledRaw = map.get(KEY_ENABLED) || 'false'
  const modeRaw = map.get(KEY_MODE) || 'messages'
  const mode = modeRaw === 'avatars' ? 'avatars' : 'messages'
  return {
    enabled: enabledRaw === 'true',
    mode,
  }
}

export async function setVisionLockedPeopleConfig(cfg: VisionLockedPeopleConfig): Promise<void> {
  const payload = [
    { key: KEY_ENABLED, value: cfg.enabled ? 'true' : 'false' },
    { key: KEY_MODE, value: cfg.mode },
  ]
  const { error } = await supabase.from('app_settings').upsert(payload, { onConflict: 'key' })
  if (error) throw error
}
